import React from 'react';
import {
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';

import {
  NavigationTabs,
  ContentWrapper,
  PaymentsDetails,
  PaymentsInvoices,
} from 'web-components';

const AccountPage = () => {
  const tabs = [
    {
      to: 'transactions',
      name: 'Transaction History',
    },
    {
      to: 'details',
      name: 'My Account',
    },
  ];

  return (
    <ContentWrapper
      header={(
        <NavigationTabs
          tabs={tabs}
        />
      )}
    >
      <Routes>
        <Route
          index
          element={<Navigate to="transactions" replace />}
        />
        <Route
          path="transactions"
          Component={PaymentsInvoices}
        />
        <Route
          path="details"
          Component={PaymentsDetails}
        />
      </Routes>
    </ContentWrapper>
  );
};

export default AccountPage;
